import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Column headers for the downloadable What's New bulk-upload template, in
 * display order. These must match the headers the backend parser reads
 * (case-insensitive, whitespace-normalized) and the Excel -> Firestore mapping.
 */
export const WHATS_NEW_TEMPLATE_COLUMNS = [
  "Feature Title",
  "Description",
  "Feature Update Type",
  "Module",
  "Max Display Duration (Days)",
  "Page URLs",
  "Feature Tag / Element Identifier",
  "Primary Button Text",
  "Primary Button Redirect URL",
  "Display Image URL",
  "Product Video URL",
  "Visibility",
  "Expiration Date",
] as const;

/** One illustrative row so users can see the expected format. */
export const WHATS_NEW_TEMPLATE_EXAMPLE_ROW: Record<string, string> = {
  "Feature Title": "Introducing AI reply suggestions",
  Description:
    "Agents now get one-tap AI-drafted replies inside every conversation.",
  "Feature Update Type": "Major",
  Module: "Helpdesk, Campaigns",
  "Max Display Duration (Days)": "60",
  "Page URLs": "/home, /settings",
  "Feature Tag / Element Identifier": "#render_button",
  "Primary Button Text": "Try it now",
  "Primary Button Redirect URL": "https://builder.bik.ai/helpdesk",
  "Display Image URL": "https://cdn.bik.ai/whats-new/ai-replies.png",
  "Product Video URL": "https://cdn.bik.ai/whats-new/ai-replies.mp4",
  Visibility: "TRUE",
  "Expiration Date": "31/12/2026",
};

/**
 * Build and trigger download of the .xlsx template (header row + example row).
 */
export const downloadWhatsNewTemplate = (): void => {
  const headerRow = [...WHATS_NEW_TEMPLATE_COLUMNS];
  const exampleRow = WHATS_NEW_TEMPLATE_COLUMNS.map(
    (col) => WHATS_NEW_TEMPLATE_EXAMPLE_ROW[col] ?? ""
  );

  const worksheet = XLSX.utils.aoa_to_sheet([headerRow, exampleRow]);
  worksheet["!cols"] = WHATS_NEW_TEMPLATE_COLUMNS.map(() => ({ wch: 28 }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Whats New");

  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "whats-new-bulk-upload-template.xlsx");
};
